export default {
  getProveData: ''
}
